import { useState, useEffect } from 'react'
import { api } from 'helpers'
import { Topic } from '../../../types'

interface AreaApiResponse {
  id: string
  name: string
}

interface UseAreasReturn {
  areas: Topic[]
  loading: boolean
  error: string | null
}

/**
 * Hook para buscar áreas da API /api/areas
 * Áreas são usadas como "topics" no formulário de criação de projeto
 */
export const useAreas = (): UseAreasReturn => {
  const [areas, setAreas] = useState<Topic[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        setLoading(true)
        const response = await api.get<AreaApiResponse[]>('/api/areas')

        const mappedAreas: Topic[] = response.data.map(area => ({
          id: area.id,
          value: area.id,
          label: area.name,
        }))

        setAreas(mappedAreas)
        setError(null)
      } catch (err) {
        setError('Failed to load areas')
        console.error('Error loading areas:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchAreas()
  }, [])

  return { areas, loading, error }
}
